import { Spinner } from "@ui-kitten/components";
import React, { useMemo } from "react";
import { RefreshControl, SectionList, SectionListData, SectionListRenderItem, View } from "react-native";
import { DataList as IDataList } from "./genericListAtom";

interface SectionDataListProps {
    sections: any[];
    data: IDataList;
    renderItem: SectionListRenderItem<any, any> | undefined;
    renderSectionHeader: ((info: { section: SectionListData<any, any> }) => React.ReactElement | null) | undefined;
    isLoading: boolean;
    refresh: () => Promise<void>;
    loadMore: () => Promise<void>;
    isLoadingMore: boolean;
    keyExtractor?: (item: any, index: number) => string;
}

export const SectionDataList: React.FC<SectionDataListProps> = ({
    data,
    sections,
    renderItem,
    renderSectionHeader,
    isLoading,
    refresh,
    loadMore,
    isLoadingMore,
    keyExtractor,
}) => {
    return useMemo(
        () => (
            <SectionList
                sections={sections}
                stickySectionHeadersEnabled={true}
                renderItem={renderItem}
                refreshing={isLoading}
                //todo change
                onRefresh={refresh}
                refreshControl={<RefreshControl refreshing={isLoading} />}
                onEndReachedThreshold={0.1}
                onEndReached={loadMore}
                keyExtractor={keyExtractor}
                renderSectionHeader={renderSectionHeader}
                ListFooterComponent={
                    isLoadingMore ? (
                        <View
                            style={{
                                height: 100,
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {(data.total || 0) > data.page * 30 && <Spinner />}
                        </View>
                    ) : (
                        <></>
                    )
                }
            />
        ),
        [
            data.page,
            data.total,
            isLoading,
            isLoadingMore,
            keyExtractor,
            loadMore,
            refresh,
            renderItem,
            sections,
            renderSectionHeader,
        ]
    );
};
